import { GetWireTransferSetupResponse } from '@/features/means-of-payments/api/useGetWireTransferSetupQuery.ts';
import { BankAccountDescription } from '@/features/means-of-payments/BankAccountDescription.tsx';
import { CreditCardDescription } from '@/features/means-of-payments/CreditCardDescription.tsx';
import { FromField } from '@/features/means-of-payments/FromField.tsx';
import { Typography } from '@arsnovasystems/ars-front-lib';
import { useTranslation } from 'react-i18next';

export const MeanOfPaymentDescription = ({
  meanOfPayment,
}: {
  meanOfPayment: GetWireTransferSetupResponse;
}) => {
  const { t } = useTranslation();
  const Fields = [];

  if (meanOfPayment.type === 'customer_balance') {
    if (meanOfPayment.virtualIban) {
      //add a space each 4 char for IBAN
      Fields.push(
        FromField(
          t('ik.meansOfPayments.account.iban.label'),
          meanOfPayment.virtualIban.replace(/(.{4})/g, '$1 ').trim(),
        ),
      );
    }

    if (meanOfPayment.virtualBic) {
      Fields.push(
        FromField(
          t('ik.meansOfPayments.account.bic.label'),
          meanOfPayment.virtualBic,
        ),
      );
    }
    if (meanOfPayment.virtualIbanCountryCode) {
      Fields.push(
        FromField(
          t('ik.meansOfPayments.account.countryCode.label'),
          meanOfPayment.virtualIbanCountryCode,
        ),
      );
    }
    if (meanOfPayment.virtualUsAccountNumber) {
      Fields.push(
        FromField(
          t('ik.meansOfPayments.account.usAccountNumber.label'),
          meanOfPayment.virtualUsAccountNumber,
        ),
      );
    }
    if (meanOfPayment.virtualUsRoutingNumber) {
      Fields.push(
        FromField(
          t('ik.meansOfPayments.account.usRoutingNumber.label'),
          meanOfPayment.virtualUsRoutingNumber,
        ),
      );
    }
  }

  return (
    <>
      {meanOfPayment.type === 'card' && (
        <CreditCardDescription meanOfPayment={meanOfPayment} />
      )}
      {meanOfPayment.type === 'sepa_debit' && (
        <BankAccountDescription meanOfPayment={meanOfPayment} />
      )}
      {meanOfPayment.type !== 'card' &&
        meanOfPayment.type !== 'sepa_debit' &&
        Fields.map((field) => (
          <Typography
            variant={'body2'}
            key={field.key}
          >
            {field}
          </Typography>
        ))}
    </>
  );
};
